// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1hj1Q","tab":"Tabs_tab__1WH_f","tabActive":"Tabs_tabActive__3lLWA"};